<template>
  <v-skeleton-loader :loading="loading" type="table">
    <v-chip-group
      v-model="selection"
      column
      active-class="active-category-class"
    >
      <v-chip pill value="archived">
        {{ $t("archived") }}
      </v-chip>
      <v-chip
        pill
        v-for="date in dates"
        :key="date"
        :value="date"
        :color="stringToHslColor(date)"
      >
        {{ date }}
      </v-chip>
    </v-chip-group>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :header-props="{ sortByText: $t('sortBy') }"
      :items="selection ? items : items.filter((e) => !e.archived)"
      sort-by="date"
      :search="selection"
      :custom-filter="customFilter"
      show-select
      item-key="_id"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item.date="{ item }">
        <v-chip
          small
          :color="item.archived ? '' : stringToHslColor(item.date)"
          >{{ item.date }}</v-chip
        >
      </template>
      <template v-slot:item.name="{ item }">
        <v-icon x-small :color="item.status ? 'success' : 'error'" class="mr-2">
          mdi-checkbox-blank-circle </v-icon
        >{{ item.name }}
      </template>
      <template v-slot:item.synonyms="{ item }">
        <v-chip
          v-for="synonym in item.synonyms"
          :key="synonym"
          class="ma-1"
          small
          >{{ synonym }}</v-chip
        >
      </template>
      <template v-slot:item.price="{ item }">
        {{ item.price }} {{ currencySymbol }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white">
          <div class="flex-grow-1"></div>
          <v-dialog
            v-model="dialog"
            max-width="800px"
            persistent
            v-if="selected.length === 0 || !$vuetify.breakpoint.xs"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" text rounded class="mb-2" v-on="on">{{
                $t("newItem")
              }}</v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">{{ formTitle }}</v-card-title>
              <v-form ref="form" v-model="valid">
                <v-card-text class="pt-0">
                  <v-container>
                    <v-row>
                      <v-col cols="auto">
                        <span class="mt-0 pt-0 mr-4 d-inline float-left"
                          >{{ $t("status") }}:</span
                        >
                        <v-switch
                          class="mt-0 pt-0 mr-4 d-inline float-left"
                          v-model="editedItem.status"
                          :label="
                            editedItem.status ? $t('active') : $t('inactive')
                          "
                          color="primary"
                          hide-details
                        ></v-switch>
                      </v-col>
                      <v-col cols="auto">
                        <span class="mt-0 pt-0 mr-4 d-inline float-left"
                          >{{ $t("deliveryOptions") }}:</span
                        >
                        <v-checkbox
                          class="mt-0 pt-0 mr-4 d-inline float-left"
                          v-model="editedItem.allowedDeliveryMethods.takeaway"
                          :label="$t('takeaway')"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          class="mt-0 pt-0 mr-4 d-inline float-left"
                          v-model="editedItem.allowedDeliveryMethods.delivery"
                          :label="$t('delivery')"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          class="mt-0 pt-0 d-inline float-left"
                          v-model="editedItem.allowedDeliveryMethods.inplace"
                          :label="$t('inplace')"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <Restrictions
                      v-if="editedItem.restrictions && !$vuetify.breakpoint.xs"
                      :restrictions="editedItem.restrictions"
                      class="mb-3"
                    ></Restrictions>
                    <v-row>
                      <!-- <v-col cols="12">
                      <span class="mt-0 pt-0 mr-4 d-inline float-left"
                        >{{ $t("status") }}:</span
                      >
                      <v-switch
                        class="mt-0 pt-0 mr-4 d-inline float-left"
                        v-model="editedItem.status"
                        :label="
                          editedItem.status ? $t('active') : $t('inactive')
                        "
                        color="primary"
                        hide-details
                      ></v-switch>
                    </v-col> -->
                      <v-col cols="12" sm="6" md="4">
                        <!-- <v-select
                        :items="categories"
                        item-text="name"
                        item-value="_id"
                        v-model="editedItem.category"
                        label="Kategória"
                        placeholder="Soups"
                        filled
                        rounded
                        clearable
                        hide-details
                      ></v-select> -->
                        <v-menu
                          v-model="datePickerMenuStatus"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.date"
                              :label="$t('date')"
                              append-icon="mdi-calendar"
                              readonly
                              filled
                              rounded
                              hide-details
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.date"
                            @input="datePickerMenuStatus = false"
                            :first-day-of-week="1"
                            :locale="calendarLanguage"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field
                          v-model="editedItem.id"
                          :label="$t('id')"
                          rounded
                          filled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="editedItem.name"
                          :label="`${$t('name')} *`"
                          :rules="[rules.required]"
                          rounded
                          filled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.description"
                          :label="$t('description')"
                          rounded
                          filled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="editedItem.allergens"
                          :items="allergens"
                          :label="$t('allergens')"
                          item-value="id"
                          item-text="name"
                          filled
                          rounded
                          chips
                          small-chips
                          deletable-chips
                          multiple
                          hide-details
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="editedItem.options"
                          :items="options"
                          :label="$t('options')"
                          item-text="name"
                          item-value="_id"
                          :no-data-text="$t('noData')"
                          filled
                          rounded
                          chips
                          small-chips
                          deletable-chips
                          multiple
                          hide-details
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-combobox
                          v-model="editedItem.synonyms"
                          :label="$t('synonyms')"
                          multiple
                          small-chips
                          rounded
                          filled
                          :hint="$t('pressEnterToCreateNewOne')"
                          append-icon
                          persistent-hint
                        ></v-combobox>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.amount"
                          :label="$t('amount')"
                          rounded
                          filled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.price"
                          :rules="[rules.required, rules.minimalValue]"
                          type="number"
                          :prefix="currencySymbol"
                          :label="`${$t('price')} *`"
                          placeholder="5,00"
                          rounded
                          filled
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col v-if="editedIndex > -1" cols="12">
                        <ImageUpload
                          type="dailyMenu"
                          :dishId="editedItem._id"
                          :imageUrl="editedItem.imageUrl"
                          @change-dish-image-url="changeDishImageUrl"
                        ></ImageUpload>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="primary" text rounded @click="close">{{
                    $t("close")
                  }}</v-btn>
                  <v-btn
                    color="success"
                    text
                    rounded
                    @click="save"
                    :disabled="!valid"
                    >{{ $t("save") }}</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="autoDetectDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-if="!$vuetify.breakpoint.xs"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" text rounded class="mb-2" v-on="on">{{
                $t("autoDetection")
              }}</v-btn>
            </template>
            <v-card>
              <v-toolbar color="secondary" dark>
                <v-btn icon @click="autoDetectDialog = false">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="white"
                    width="24px"
                    height="24px"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                  </svg>
                </v-btn>
                <v-toolbar-title>{{ $t("autoDetection") }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                    text
                    :loading="autoDetectLoading"
                    @click="$refs.autodetect.addDailyMenuDishes()"
                    >{{ $t("import") }}</v-btn
                  >
                </v-toolbar-items>
              </v-toolbar>
              <AutoDetect
                v-on:loading="autoDetectLoading = true"
                v-on:updateItems="onUpdateItems"
                ref="autodetect"
              ></AutoDetect>
            </v-card>
          </v-dialog>

          <v-btn
            v-if="selected.length === 0 || !$vuetify.breakpoint.xs"
            @click="archiveExpiredDishes()"
            text
            rounded
            color="primary"
            class="mb-2"
          >
            {{ $t("archiveExpired") }}
          </v-btn>

          <v-dialog
            v-if="selected.length !== 0"
            v-model="bulkActionDialog"
            max-width="800px"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" text rounded class="mb-2" v-on="on">{{
                $t("bulkAction")
              }}</v-btn>
            </template>
            <v-card>
              <v-toolbar color="secondary" dark>
                <v-btn icon @click="bulkActionDialog = false">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="white"
                    width="24px"
                    height="24px"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                  </svg>
                </v-btn>
                <v-toolbar-title>{{ $t("bulkAction") }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <span>{{
                  $t("nItemsSelected", { amount: selected.length })
                }}</span>
                <v-progress-circular
                  v-if="bulkActionLoading"
                  indeterminate
                  color="white"
                  class="ml-4"
                ></v-progress-circular>
              </v-toolbar>
              <BulkAction
                mode="dailyMenu"
                :selected="selected"
                :availableOptions="options"
                v-on:loading="bulkActionLoading = true"
                v-on:updateItems="onUpdateItems"
              ></BulkAction>
            </v-card>
          </v-dialog>
          <br />
          <v-btn
            v-if="selected.length !== 0"
            @click="deleteSelected"
            text
            rounded
            color="error"
            class="mb-2"
          >
            {{ $t("remove") }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        {{ $t("noData") }}
      </template>
    </v-data-table>
  </v-skeleton-loader>
</template>

<script>
import restaurantService from "../services/restaurant.service";

import AutoDetect from "../components/AutoDetect";
import BulkAction from "../components/BulkAction";
import Restrictions from "../components/Restrictions";
import ImageUpload from "../components/ImageUpload.vue";

export default {
  components: {
    AutoDetect,
    BulkAction,
    Restrictions,
    ImageUpload,
  },
  data() {
    return {
      loading: true,
      valid: true,
      rules: {
        required: (value) =>
          (value !== "" && value !== null) || this.$t("requiredField"),
        minimalValue: (value) =>
          Number(value) >= 0 || this.$t("minimalAmountIs", { amount: 0 }),
      },
      dialogCategory: false,
      autoDetectDialog: false,
      autoDetectLoading: false,
      bulkActionDialog: false,
      bulkActionLoading: false,
      selection: null,
      dialog: false,
      datePickerMenuStatus: false,
      categories: [],
      categoryEditedIndex: -1,
      defaultCategory: {
        name: "",
        rank: null,
        color: "",
      },
      editedCategory: {
        name: "",
        rank: null,
        color: "",
      },
      headers: [
        { text: this.$t("date"), value: "date" },
        { text: this.$t("id"), value: "id" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("synonyms"), value: "synonyms", sortable: false },
        { text: this.$t("description"), value: "description", sortable: false },
        { text: this.$t("amount"), value: "amount", sortable: false },
        { text: this.$t("price"), value: "price" },
        { text: this.$t("actions"), value: "action", sortable: false },
      ],
      items: [],
      selected: [],
      options: [],
      // allergens: [
      //   "1. Obilniny",
      //   "2. Kôrovce",
      //   "3. Vajcia",
      //   "4. Ryby",
      //   "5. Arašidy",
      //   "6. Sójové zrná",
      //   "7. Mlieko",
      //   "8. Orechy",
      //   "9. Zeler",
      //   "10. Horčica",
      //   "11. Sezamové semená",
      //   "12. Oxid siričitý a siričitany",
      //   "13. Vlčí bôb",
      //   "14. Mäkkýše",
      // ],
      allergens: [
        { id: "1", name: this.$t("allergen1") },
        { id: "2", name: this.$t("allergen2") },
        { id: "3", name: this.$t("allergen3") },
        { id: "4", name: this.$t("allergen4") },
        { id: "5", name: this.$t("allergen5") },
        { id: "6", name: this.$t("allergen6") },
        { id: "7", name: this.$t("allergen7") },
        { id: "8", name: this.$t("allergen8") },
        { id: "9", name: this.$t("allergen9") },
        { id: "10", name: this.$t("allergen10") },
        { id: "11", name: this.$t("allergen11") },
        { id: "12", name: this.$t("allergen12") },
        { id: "13", name: this.$t("allergen13") },
        { id: "14", name: this.$t("allergen14") },
      ],
      editedIndex: -1,
      editedItem: {
        status: true,
        allowedDeliveryMethods: {
          delivery: true,
          takeaway: true,
          inplace: true,
        },
        date: new Date().toISOString().substr(0, 10),
        id: "",
        name: "",
        category: "",
        synonyms: [],
        allergens: [],
        options: [],
        description: "",
        amount: "",
        price: null,
        imageUrl: "",
      },
      defaultItem: {
        status: true,
        allowedDeliveryMethods: {
          delivery: true,
          takeaway: true,
          inplace: true,
        },
        date: new Date().toISOString().substr(0, 10),
        id: "",
        name: "",
        category: "",
        synonyms: [],
        allergens: [],
        options: [],
        description: "",
        amount: "",
        price: null,
        imageUrl: "",
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addNewDishToDailyMenu")
        : this.$t("editDish");
    },
    categoryFormTitle() {
      return this.categoryEditedIndex === -1
        ? this.$t("addNewCategory")
        : this.$t("editCategory");
    },
    dates() {
      let dates = [];
      this.items.forEach((item) => {
        if (dates.indexOf(item.date) === -1 && !item.archived)
          dates.push(item.date);
      });
      return dates.sort();
    },
    calendarLanguage() {
      switch (this.$i18n.locale) {
        case "sk":
          return "sk-SK";
        case "cs":
          return "cs-CZ";
        default:
          return "en-GB";
      }
    },
    currencySymbol() {
      return localStorage.currencySymbol;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogCategory(val) {
      val || this.closeCategory();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      const resp = await restaurantService.getRestaurant(
        localStorage.restaurantId,
        "dailyMenu,options,categories"
      );
      this.items = resp.dailyMenu;
      this.options = resp.options;
      this.categories = resp.categories.sort(
        (a, b) => parseFloat(a.rank) - parseFloat(b.rank)
      );
      this.loading = false;
    },

    customFilter(value, search, item) {
      if (search === "archived") return item.archived;
      return (
        value != null &&
        search != null &&
        item.date != null &&
        item.date === search &&
        !item.archived
      );
    },

    // editCategory(category) {
    //   this.categoryEditedIndex = this.categories.indexOf(category);
    //   this.editedCategory = Object.assign({}, category);
    //   this.dialogCategory = true;
    // },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // async deleteCategory(category) {
    //   if (window.confirm("Are you sure you want to delete this category?")) {
    //     const resp = await restaurantService.removeCategory(
    //       localStorage.getItem("restaurantId"),
    //       category._id
    //     );
    //     this.categories = resp.sort(
    //       (a, b) => parseFloat(a.rank) - parseFloat(b.rank)
    //     );
    //     this.closeCategory();
    //   }
    // },

    async deleteItem(item) {
      if (window.confirm(this.$t("areYouSureYouWantToDeleteThisItem"))) {
        this.loading = true;
        const resp = await restaurantService.removeDailyMenuDish(
          localStorage.getItem("restaurantId"),
          item._id
        );
        // TODO
        this.items = this.items.filter((e) => e._id !== resp.dishId);
        this.loading = false;
      }
    },

    async deleteSelected() {
      if (
        window.confirm(
          this.$t("areYouSureYouWantToRemoveDishes", {
            amount: this.selected.length,
          })
        )
      ) {
        let ids = [];
        this.selected.forEach((e) => {
          ids.push(e._id);
        });
        const resp = await restaurantService.removeDailyMenuDishes(
          localStorage.getItem("restaurantId"),
          ids
        );
        this.selected = [];
        this.items = resp;
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    // closeCategory() {
    //   this.dialogCategory = false;
    //   setTimeout(() => {
    //     this.editedCategory = Object.assign({}, this.defaultCategory);
    //     this.categoryEditedIndex = -1;
    //   }, 300);
    // },

    async save() {
      if (this.editedIndex > -1) {
        const resp = await restaurantService.editDailyMenuDish(
          localStorage.getItem("restaurantId"),
          this.editedItem
        );
        // TODO
        this.updateItems(resp);
      } else {
        const resp = await restaurantService.addDailyMenuDish(
          localStorage.getItem("restaurantId"),
          this.editedItem
        );
        // TODO
        this.updateItems(resp);
      }
      this.close();
    },

    changeDishImageUrl(event) {
      const index = this.items.findIndex(
        (e) => `${e._id}` === `${event.dishId}`
      );
      let item = this.items[index];
      item.imageUrl = event.imageUrl;
      this.updateItems(item);
      this.$set(this.editedItem, "imageUrl", event.imageUrl);
    },

    updateItems(item) {
      const index = this.items.findIndex((e) => e._id === item._id);
      if (index === -1) this.items.push(item);
      else this.$set(this.items, index, item);
    },

    onUpdateItems(items) {
      this.items = items;
      this.autoDetectLoading = false;
      this.autoDetectDialog = false;

      this.bulkActionDialog = false;
      this.bulkActionLoading = false;
    },

    stringToHslColor: function (str, s = 100, l = 75) {
      let revStr = str.split("").reverse().join("");
      let hash = 0;
      for (let i = 0; i < revStr.length; i++) {
        hash = revStr.charCodeAt(i) + ((hash << 5) - hash);
      }

      const h = hash % 360;
      return "hsl(" + h + ", " + s + "%, " + l + "%)";
    },

    async archiveExpiredDishes() {
      const expiredDishes = this.items.filter(
        (dish) =>
          !dish.archived &&
          new Date().setHours(0, 0, 0, 0) >
            new Date(dish.date).setHours(0, 0, 0, 0)
      );

      if (
        window.confirm(
          this.$t("areYouSureYouWantToArchiveDishes", {
            amount: expiredDishes.length,
          })
        )
      ) {
        let ids = [];
        expiredDishes.forEach((e) => {
          ids.push(e._id);
        });

        this.loading = true;

        const resp = await restaurantService.bulkAction(
          localStorage.getItem("restaurantId"),
          "dailyMenu",
          ids,
          "archived",
          true
        );

        this.items = resp;
        this.loading = false;
      }
    },

    // async saveCategory() {
    //   if (this.categoryEditedIndex > -1) {
    //     const resp = await restaurantService.editCategory(
    //       localStorage.getItem("restaurantId"),
    //       this.editedCategory
    //     );
    //     this.categories = resp.sort(
    //       (a, b) => parseFloat(a.rank) - parseFloat(b.rank)
    //     );
    //   } else {
    //     const resp = await restaurantService.addCategory(
    //       localStorage.getItem("restaurantId"),
    //       this.editedCategory
    //     );
    //     this.categories = resp.sort(
    //       (a, b) => parseFloat(a.rank) - parseFloat(b.rank)
    //     );
    //   }
    //   this.closeCategory();
    // },
  },
};
</script>

<style>
.active-category-class {
  font-weight: bold;
}

.v-data-table .v-toolbar__content {
  float: left;
  padding: 0;
}
</style>